declare namespace $ {

	export class $mol_icon_earth extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=earth.view.tree.d.ts.map